"use strict";

var index = 0;

module.exports = {
  generate: function generate() {
    return "mui-id-" + index++;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/lib/utils/unique-id.js
// module id = 89
// module chunks = 0